import { render, staticRenderFns } from "./LegacyCaseStudy.vue?vue&type=template&id=8cf66742&"
import script from "./LegacyCaseStudy.vue?vue&type=script&lang=js&"
export * from "./LegacyCaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./LegacyCaseStudy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports